export const ARTIFACT_VERSION_SELECTION_PAGE_SIZE = 6;
export const ARTIFACT_VERSION_SELECTION_FETCH_PAGE_SIZE =
  ARTIFACT_VERSION_SELECTION_PAGE_SIZE * 3;
export const ARTIFACT_VERSION_SELECTION_LIMIT = 20;

type VersionSelectionRow = {
  membershipId: string;
};

export function getInitialArtifactVersionMembershipIds(
  pageRows: VersionSelectionRow[]
) {
  return clampArtifactVersionMembershipSelection(
    pageRows
      .slice(0, ARTIFACT_VERSION_SELECTION_PAGE_SIZE)
      .map(row => row.membershipId)
      .filter(membershipId => membershipId !== '')
  );
}

export function clampArtifactVersionMembershipSelection(
  selectedMembershipIds: string[]
) {
  return selectedMembershipIds.slice(0, ARTIFACT_VERSION_SELECTION_LIMIT);
}

export function toggleMembershipSelection(
  selectedMembershipIds: string[],
  membershipId: string
) {
  if (selectedMembershipIds.includes(membershipId)) {
    return selectedMembershipIds.filter(id => id !== membershipId);
  }
  if (selectedMembershipIds.length >= ARTIFACT_VERSION_SELECTION_LIMIT) {
    return clampArtifactVersionMembershipSelection(selectedMembershipIds);
  }
  return clampArtifactVersionMembershipSelection([
    ...selectedMembershipIds,
    membershipId,
  ]);
}

export function togglePageMembershipSelection(
  selectedMembershipIds: string[],
  pageMembershipIds: string[]
) {
  const pageMembershipIdSet = new Set(pageMembershipIds);
  const allPageMembershipsSelected =
    pageMembershipIds.length > 0 &&
    pageMembershipIds.every(id => selectedMembershipIds.includes(id));

  if (allPageMembershipsSelected) {
    return selectedMembershipIds.filter(id => !pageMembershipIdSet.has(id));
  }

  const nextSelection = clampArtifactVersionMembershipSelection([
    ...selectedMembershipIds,
  ]);
  for (const membershipId of pageMembershipIds) {
    if (nextSelection.includes(membershipId)) {
      continue;
    }
    if (nextSelection.length >= ARTIFACT_VERSION_SELECTION_LIMIT) {
      break;
    }
    nextSelection.push(membershipId);
  }
  return nextSelection;
}
